import { UsersService } from './users.service';

export default angular
  .module('sfMobile.services.users', [
    'sfMobile.services.pov',
    'sfMobile.services.access-rights',
  ])
  .service('usersService', UsersService).name;
